import {
  Button,
  createTableColumn,
  Input,
  Label,
  Link,
  TableColumnDefinition,
} from "@fluentui/react-components";
import i18n from "i18next";
import React, { useState } from "react";
import { IUserDocument } from "../../../Models/IUserDocument";
import { ILogEntry } from "../../../Models/ILogEntry";
import {
  CheckmarkCircle16Regular,
  DismissCircle16Regular,
  Info16Regular,
  Warning16Regular,
} from "@fluentui/react-icons";

interface ILoggingColumnsProps {}

export function LoggingColumns(props: ILoggingColumnsProps) {
  const columns: TableColumnDefinition<ILogEntry>[] = [
    createTableColumn<ILogEntry>({
      columnId: "timeStamp",
      compare: (a, b) => {
        if (a.timeStamp && b.timeStamp) {
          return a.timeStamp.localeCompare(b.timeStamp);
        } else return 0;
      },
      renderHeaderCell: () => {
        return "Datum / Uhrzeit";
      },
      renderCell: (item) => {
        return <div>{new Date(item.timeStamp).toLocaleString()}</div>;
      },
    }),
    createTableColumn<ILogEntry>({
      columnId: "type",
      compare: (a, b) => {
        if (a.type && b.type) {
          return a.type.localeCompare(b.type);
        } else return 0;
      },
      renderCell: (item) => {
        if (item.type == "ERROR") {
          return <DismissCircle16Regular color="red" />;
        } else if (item.type == "WARNING") {
          return <Warning16Regular color="orange" />;
        } else if (item.type == "PROGRESS") {
          return <CheckmarkCircle16Regular color="green" />;
        } else {
          return <Info16Regular />;
        }
      },
    }),
    createTableColumn<ILogEntry>({
      columnId: "message",
      compare: (a, b) => {
        if (a.message && b.message) {
          return a.message.localeCompare(b.message);
        } else return 0;
      },
      renderHeaderCell: () => {
        return "Nachricht";
      },
      renderCell: (item) => {
        return (
          <div>
            <div
              style={{
                fontSize: "small",
                color:
                  item.type == "ERROR"
                    ? "red"
                    : item.type == "PROGRESS"
                    ? "green"
                    : item.type == "WARNING"
                    ? "orange"
                    : "black",
              }}
            >
              {item.method}
            </div>
            <div>{item.message}</div>
          </div>
        );
      },
    }),
    createTableColumn<ILogEntry>({
      columnId: "reference",
      compare: (a, b) => {
        if (a.reference && b.reference) {
          return a.reference.localeCompare(b.reference);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("kundenReferenz");
      },
      renderCell: (item) => {
        return item.reference;
      },
    }),
  ];

  return columns;
}
